<div class="flex flex-row w-full">
    <ul class="pagination items-center justify-content-center">
        <li class="page-item" [class.disabled]="current <= 1">
            <a class="page-link page-link--with-arrow" aria-label="Previous" (click)="setPage(1)">
                <mat-icon>keyboard_double_arrow_left</mat-icon>
            </a>
        </li>
        <li class="page-item" [class.disabled]="current <= 1">
            <a class="page-link page-link--with-arrow" aria-label="Previous" (click)="setPage(current - 1)">
                <mat-icon>navigate_before</mat-icon>
                <!-- <app-icon class="page-link__arrow page-link__arrow--left" aria-hidden="true" name="arrow-rounded-left-8x13" size="8x13"></app-icon> -->
            </a>
        </li>

        <div class="pages-container">
            <li *ngFor="let page of pages; trackBy: trackByFn" class="page-item" [class.active]="page === current">
                <a class="page-linkk" (click)="setPage(page)">
                    <div class="page-circle cursor-pointer">
                        <span class="number">{{ page }}</span>
                    </div>
                    <!-- <span *ngIf="page === current" class="sr-only">(current)</span> -->
                </a>
            </li>
        </div>
        <li class="page-item" [class.disabled]="current >= total">
            <a class="page-link page-link--with-arrow" aria-label="Next" (click)="setPage(current + 1)">
                <mat-icon>navigate_next</mat-icon>
                <!-- <app-icon class="page-link__arrow page-link__arrow--right" aria-hidden="true" name="arrow-rounded-right-8x13" size="8x13"></app-icon> -->
            </a>
        </li>
        <li class="page-item" [class.disabled]="current >= total">
            <a class="page-link page-link--with-arrow" aria-label="Previous" (click)="setPage(total)">
                <mat-icon>keyboard_double_arrow_right</mat-icon>
            </a>
        </li>
    </ul>

    <div class="mobile:hidden flex flex-row page-controls">
        <span>{{'page'|translate}}</span>
        <input type="number" [placeholder]="current||''" [formControl]="pagecontrol">
        <button type="button cursor-pointer" [disabled]="!pagecontrol.value">
            <div class="label" (click)="setPage(pagecontrol.value||current)">{{'go'|translate}}</div>
        </button>
    </div>
</div>